import { isString } from 'lodash';

//! This use to handle mounted or unmounted component via redux

export const typeUnmounted = (components = '') => {
  if (isString(components)) {
    return `${components}_UNMOUNTED`;
  }

  return '';
};

export const typeMounted = (components = '') => {
  if (isString(components)) {
    return `${components}_MOUNTED`;
  }

  return '';
};

export default {
  homepage: 'HOME_PAGE',
  statistics: 'STATISTIC',
  contacts: 'CONTACTS',
  contactDetail: 'CONTACT_DETAIL',
  tickets: 'PAGE_TICKETS',
  send: 'SEND',
  notifications: 'NOTIFICATION',
  dids: 'DID_GROUPS',
  didsDetail: 'DID_DETAIL',
  messageStats: 'MESSAGE_STATS',
  domainDetail: 'DOMAIN_DETAIL',
  monitoring: 'MONITORING',
  creative: 'CREATIVE',
};
